import type { QueryClient, QueryKey } from '@tanstack/react-query';

export const cancelAndInvalidateQueries = async (queryClient: QueryClient, queryKey: QueryKey) => {
  await queryClient.cancelQueries({ queryKey });
  await queryClient.invalidateQueries({ queryKey });
};
